import createBrowserHistory from 'history/createBrowserHistory'

const history = createBrowserHistory()
// const base = document.getElementsByTagName('base')[0]
// const params = base ? {basename: base.getAttribute('href')} : {}

export default history
export const { push, replace } = history



// WEBPACK FOOTER //
// ./app/history.js